<template>
  <div>
    <div v-for="category in categories" :key="category.category">
      <v-card-title>
        {{ $t(`stepModelRequirementCategory.${category.category}.name`) }}
      </v-card-title>

      <v-card-text v-if="audited && category.weight">
        {{ $tc(`report.category.finalResult`, category.stars, { stars: category.stars }) }}
      </v-card-text>

      <v-simple-table class="v-align-top table-no-hover">
        <template #default>
          <tbody>
            <template>
              <tr v-for="requirement in category.requirements" :key="requirement.id">
                <td width="50%">
                  <strong>
                    {{ $t(`stepModelRequirement.${requirement.requirementId}.name`) }}
                  </strong>

                  <Markdown :value="$t(`stepModelRequirement.${requirement.requirementId}.description`)" />
                </td>

                <td>
                  <div>
                    <Markdown
                      :value="
                        audited
                          ? requirement.result.description
                          : $t('fund.report.requirementNotAudited', fund.language)
                      "
                    />
                  </div>

                  <div
                    v-if="
                      type === 'provisional' &&
                        fund.mayGiveFeedback &&
                        !audit &&
                        !audituser &&
                        !requirement.auditorFeedback
                    "
                    class="mt-4"
                  >
                    <StepModelRequirementUserFeedbackForm :requirement="requirement" />
                  </div>
                </td>

                <td v-if="audited && audit">
                  <Markdown :value="requirement.result.applicable ? requirement.result.points : 'NA'" />
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>

      <StepModelRequirementsCategories
        v-if="category.children.length"
        :fund="fund"
        :categories="category.children"
        :audit="audit"
        :audituser="audituser"
        :audited="audited"
        :type="type"
      />
    </div>
  </div>
</template>

<script>
import StepModelRequirementUserFeedbackForm from "./StepModelRequirementUserFeedbackForm.vue";

export default {
  name: "StepModelRequirementsCategories",

  components: {
    StepModelRequirementUserFeedbackForm,
  },

  props: {
    fund: {
      type: Object,
      required: true,
    },

    categories: {
      type: Array,
      required: true,
    },

    audit: {
      type: Boolean,
      default: false,
    },

    audituser: {
      type: Boolean,
      default: false,
    },

    audited: {
      type: Boolean,
      default: true,
    },

    type: {
      type: String,
      default: "final",
    },
  },
};
</script>
